// extracted by mini-css-extract-plugin
module.exports = {"content":"AppContent_content__3T_du"};